import { render, staticRenderFns } from "./setObdConfig.vue?vue&type=template&id=76719408&lang=html"
import script from "./setObdConfig.vue?vue&type=script&lang=js"
export * from "./setObdConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports